import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../shared/services/app.service';
import { RequestService } from '../../shared/services/request.service';
import { Request } from "../../shared/models/request.model";

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {

  private sub: any;
  public request : Request = new Request();

  public isTermsAgreed: boolean = false;


  constructor(private router: Router, private appService: AppService, private activatedRoute: ActivatedRoute, public requestService: RequestService) { }

  ngOnInit(): void {
    this.appService.setProgress("100");
    
    this.sub = this.activatedRoute.params.subscribe((params) => {
      this.requestService.getRequestById(params["requestId"]).subscribe(data => {
        this.request = data
      })
    })
  }

  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  onSubmit(){
    this.sub = this.requestService.putRequest(this.request).subscribe(data => {
      
      this.request = data;
      this.router.navigate(["/status/" + this.request.id]);
    });
  }

}
